import styled from '@emotion/styled';

export default styled.section`
    .layout-container {
        .section-articles {
            padding: 2em 0 4em;
        }
    }
`;
